import { useAuth } from "@auth/AuthContext"

import { DEFAULT_ACADEMIC_CONFIG, type AcademicConfig } from "@/types"

/**
 * Reads the tenant academic config the backend resolved for the authenticated
 * professor's school (School override → Institution). PRD-38 / ADR-0032.
 *
 * Professors don't configure any of this — an admin does, once per
 * institution. Consumers: the Periodo select on classroom creation (options
 * are `1..periods_per_cycle`, label derived from `period_type`) and the
 * classroom card's period line. For the grade scale specifically, keep using
 * `useGradeScale()` — its ~20 consumers already depend on that signature.
 */
export const useAcademicConfig = (): AcademicConfig => {
  const { professor } = useAuth()
  return professor?.academic_config ?? DEFAULT_ACADEMIC_CONFIG
}
